// extracted by mini-css-extract-plugin
export default {"headerComponent":"styles_headerComponent__59Ar3","active":"styles_active__ZTrDD","rotateToBottom":"styles_rotateToBottom__t1wk+","rotateToTop":"styles_rotateToTop__g-Sy0"};